import {
  getRouteApi,
  type RegisteredRouter,
  type RouteIds,
  type SearchParamOptions,
} from '@tanstack/react-router'

/**
 * Retire les critères « vides » avant de les écrire dans l'URL : la forme exacte
 * du search est celle de la route appelante, elle traverse donc le helper sans
 * être élargie (`T` est conservé de bout en bout).
 */
const cleanEmptyParams = <T extends object>(search: T) => {
  return Object.fromEntries(
    Object.entries(search).filter(
      ([, value]) => value !== undefined && value !== '' && !Number.isNaN(value)
    )
  ) as T
}

export function useFilters<
  TId extends RouteIds<RegisteredRouter['routeTree']>,
  TSearchParams extends SearchParamOptions<RegisteredRouter, TId, TId>['search'],
>(routeId: TId) {
  const routeApi = getRouteApi<TId>(routeId)
  const navigate = routeApi.useNavigate()
  const filters = routeApi.useSearch()

  const setFilters = (partialFilters: Partial<TSearchParams>) =>
    void navigate({
      search: cleanEmptyParams(Object.assign({}, filters, partialFilters)) as TSearchParams,
    })

  const resetFilters = () => void navigate({ search: {} as TSearchParams })

  return { filters, resetFilters, setFilters }
}
